/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AIModelProgress
 */
export interface AIModelProgress {
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof AIModelProgress
     */
    status: { [key: string]: string | undefined; };
    /**
     * 
     * @type {Date}
     * @memberof AIModelProgress
     */
    eta: Date | null;
}

export function AIModelProgressFromJSON(json: any): AIModelProgress {
    return AIModelProgressFromJSONTyped(json, false);
}

export function AIModelProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIModelProgress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'eta': (json['eta'] === null ? null : new Date(json['eta'])),
    };
}

export function AIModelProgressToJSON(value?: AIModelProgress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'eta': (value.eta === null ? null : value.eta.toISOString()),
    };
}


